import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import hilux from "../../../../assets/info/hilux-4wd-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const ToyotaHilux = () => {
  useSmallNav("Toyota Hilux 4WD");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Toyota Hilux 4WD"} bolder />
        <InfoHero image={hilux} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Get the ultimate in sports suspension for your Toyota Hilux"
              }
            />
            <p>
              Trak Ryder 4WD Suspension represents many years of technical
              development and delivers new levels of ride and comfort for the
              4-wheel drive Hilux owner. Pedders Trak Ryder suspension includes
              hundreds of quality components in its construction each designed
              to improve the ride and handling of specific vehicles in specific
              ways.
            </p>
            <p>
              The success of the Pedders Trak Ryder 4WD suspension system is not
              governed by product alone. Trak Ryder is a tailored system and
              much of its prowess can be attributed to the fact that the system
              can be 'custom built' to suit any 4x4 vehicle. With Trak Ryder it
              is possible to enjoy all the aspirational tough qualities of a
              4-wheel drive escape vehicle yet with the handling and ride
              characteristics of a sedan. For owners of newer vehicles, Trak
              Ryder brings an end to the age-old compromise of owning a 4-wheel
              drive and having to compromise on ride and comfort.
            </p>
            <p>
              Whether it be for every day driving, lift kits or towing and load
              carrying you can be rest assured that your UK Pedders Suspension
              specialist can tailor a Trak Ryder suspension system to suit your
              driving needs.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/FLQI_XYj4Bc"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5olMu1M-eJ8"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Toyota Hilux Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Toyota")
              .models.find((e) => e.display === "Hilux 4WD")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <InfoFooter make="Toyota" model="Hilux 4WD" />
      </Container>
    </section>
  );
};

export default ToyotaHilux;
